export const formatCreatedDate = (createdDate) => {
  const created = new Date(createdDate);
  const today = new Date();

  const diffTime = Math.abs(today - created);
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "Yesterday";
  return `${diffDays} days ago`;
};

export const formatDate = (dateString) => {
  if (!dateString) return "N/A"; // Kiểm tra nếu không có dữ liệu

  const date = new Date(dateString);
  return date.toLocaleString("vi-VN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

export const formatPrice = (price) => {
  return price.toLocaleString("vi-VN", {
    style: "currency",
    currency: "VND",
  });
};

export const formattedDateTime = (dateTimeString) => {
  return new Intl.DateTimeFormat("en-GB").format(new Date(dateTimeString));
};

export const countDays = (startDate1, endDate1) => {
  const startDate = new Date(startDate1);
  const endDate = new Date(endDate1);
  return Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
};

export const statusBookingClassName = (status) => {
  //switch case
  switch (status) {
    case "pending":
      return "badge badge-secondary";
    case "Upcoming":
      return "badge badge-info";
    case "Completed":
      return "badge badge-success";
    case "Cancelled":
      return "badge badge-danger";
    default:
      return "badge badge-secondary";
  }
};

export const truncateText = (text, maxWords) => {
  const words = text.split(" ");
  return words.length > maxWords
    ? words.slice(0, maxWords).join(" ") + "..."
    : text;
};

export const formatDateVietNam = (utcDate) => {
  return new Date(utcDate).toLocaleString("vi-VN", {
    timeZone: "Asia/Ho_Chi_Minh",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

export const formatUtcTime = (utcTime) => {
  return new Date(utcTime).toISOString().replace("T", " ").substring(0, 19);
};
